export var initials = function (name, glue) {
  if (glue === void 0) {
    glue = '';
  }
  return name.split(' ').map(function (word) {
    return word[0];
  }).join(glue);
};